/*
  LegMedMig — leveringsestimat

  Regner i browseren, ikke i Liquid: Shopify cacher produktsider, så en
  serverberegnet "bestil inden kl. 11" kan blive serveret fra cachen
  længe efter fristen er udløbet.

  Butikkens tidszone kommer fra Liquid som UTC-offset, så beregningen
  følger butikkens dag — ikke den besøgendes.
*/
(function () {
  'use strict';

  var DAGE = ['søndag', 'mandag', 'tirsdag', 'onsdag', 'torsdag', 'fredag', 'lørdag'];
  var MDR = [
    'januar',
    'februar',
    'marts',
    'april',
    'maj',
    'juni',
    'juli',
    'august',
    'september',
    'oktober',
    'november',
    'december',
  ];

  /* "+0200" -> minutter */
  function parseOffset(raw) {
    var m = /^([+-])(\d{2})(\d{2})$/.exec((raw || '').trim());
    if (!m) return null;
    var mins = parseInt(m[2], 10) * 60 + parseInt(m[3], 10);
    return m[1] === '-' ? -mins : mins;
  }

  /* Nu, forskudt til butikkens tidszone. Vi læser bagefter kun UTC-felter,
     så værdierne svarer til butikkens vægur. getTime() er altid UTC, så
     den besøgendes egen tidszone må ikke lægges til - så gik uret 2 timer
     bagud for danske besøgende. */
  function shopNow(offsetMinutes) {
    return new Date(Date.now() + offsetMinutes * 60 * 1000);
  }

  function ymd(d) {
    return (
      d.getUTCFullYear() +
      '-' +
      String(d.getUTCMonth() + 1).padStart(2, '0') +
      '-' +
      String(d.getUTCDate()).padStart(2, '0')
    );
  }

  /* ISO-ugedag: 1 = mandag ... 7 = søndag */
  function isoDay(d) {
    return d.getUTCDay() === 0 ? 7 : d.getUTCDay();
  }

  function addDays(d, n) {
    var c = new Date(d.getTime());
    c.setUTCDate(c.getUTCDate() + n);
    return c;
  }

  function canShip(d, shipDays, closedDates) {
    return shipDays.indexOf(isoDay(d)) !== -1 && closedDates.indexOf(ymd(d)) === -1;
  }

  /* Første afsendelsesdag fra og med `from`. Loftet på 60 dage er en
     sikkerhedsventil: er alle ugedage fravalgt, ville løkken køre evigt. */
  function nextShipDay(from, shipDays, closedDates) {
    var d = from;
    for (var i = 0; i < 60; i++) {
      if (canShip(d, shipDays, closedDates)) return d;
      d = addDays(d, 1);
    }
    return null;
  }

  function formatDate(d) {
    return 'd. ' + d.getUTCDate() + '. ' + MDR[d.getUTCMonth()];
  }

  function init(box) {
    if (box.dataset.lmmDeliveryDone === '1') return;

    var cutoffEl = box.querySelector('[data-lmm-delivery-cutoff]');
    var etaEl = box.querySelector('[data-lmm-delivery-eta]');
    if (!cutoffEl || !etaEl) return;

    var offset = parseOffset(box.dataset.tzOffset);
    if (offset === null) return; /* uden tidszone: behold serverens fallback */

    var shipDays = (box.dataset.shipDays || '1,2,3,4,5')
      .split(',')
      .map(function (x) {
        return parseInt(x.trim(), 10);
      })
      .filter(function (x) {
        return x >= 1 && x <= 7;
      });
    if (!shipDays.length) return;

    var closedDates = (box.dataset.closed || '')
      .split(/[,\n]/)
      .map(function (x) {
        return x.trim();
      })
      .filter(Boolean);

    /* Leveringsdage er ikke det samme som afsendelsesdage. Pakken kan
       afleveres fredag, men GLS leverer ikke loerdag - saa "i morgen"
       ville vaere et loefte, der ikke holder. */
    var deliverDays = (box.dataset.deliverDays || '1,2,3,4,5')
      .split(',')
      .map(function (x) {
        return parseInt(x.trim(), 10);
      })
      .filter(function (x) {
        return x >= 1 && x <= 7;
      });
    if (!deliverDays.length) deliverDays = [1, 2, 3, 4, 5];

    function nextDeliveryDay(from) {
      var d = from;
      for (var i = 0; i < 30; i++) {
        if (deliverDays.indexOf(isoDay(d)) !== -1) return d;
        d = addDays(d, 1);
      }
      return d;
    }

    /* Sidste bestillingstidspunkt. Enkelte dage kan have et andet end resten
       - fx en enkelt fredag, hvor fragtfirmaet henter tidligere. Skrives i
       Temaindstillinger > Levering, én pr. linje:
         2026-10-09: 9   en bestemt dato
         fredag: 9       hver uge
       En dato vinder over en ugedag, og datoer i fortiden gør ingenting. */
    var cutoffStandard = parseInt(box.dataset.cutoff, 10);
    var DAGSNAVNE = { man: 1, tir: 2, ons: 3, tor: 4, fre: 5, lør: 6, lor: 6, søn: 7, son: 7 };
    var cutoffPerDato = {};
    var cutoffPerUgedag = {};
    (box.dataset.cutoffExceptions || '').split(/[,\n]/).forEach(function (raekke) {
      var m = /^\s*([^:]+?)\s*:\s*(\d{1,2})\s*$/.exec(raekke);
      if (!m) return;
      var navn = m[1].toLowerCase();
      var time = parseInt(m[2], 10);
      if (/^\d{4}-\d{2}-\d{2}$/.test(navn)) {
        cutoffPerDato[navn] = time;
        return;
      }
      var dag = /^[1-7]$/.test(navn) ? parseInt(navn, 10) : DAGSNAVNE[navn.slice(0, 3)];
      if (dag) cutoffPerUgedag[dag] = time;
    });

    function cutoffFor(d) {
      var t = cutoffPerDato[ymd(d)];
      if (t === undefined) t = cutoffPerUgedag[isoDay(d)];
      return t === undefined ? cutoffStandard : t;
    }

    var dMin = parseInt(box.dataset.daysMin, 10) || 1;
    var dMax = parseInt(box.dataset.daysMax, 10) || 2;
    var carrier = box.dataset.carrier || 'GLS';

    var now = shopNow(offset);
    var today = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));
    var cutoff = cutoffFor(today);
    var beforeCutoff = now.getUTCHours() < cutoff;

    /* Sender vi i dag, eller er dagen kørt? */
    var shipDate;
    if (canShip(today, shipDays, closedDates) && beforeCutoff) {
      shipDate = today;
      cutoffEl.innerHTML =
        'Bestil inden <strong>kl. ' + ('0' + cutoff).slice(-2) + ':00</strong> i dag, så sender vi i dag med ' + carrier;
    } else {
      shipDate = nextShipDay(addDays(today, 1), shipDays, closedDates);
      if (!shipDate) return;
      var naer = ymd(shipDate) === ymd(addDays(today, 1)) ? 'i morgen' : DAGE[shipDate.getUTCDay()] + ' ' + formatDate(shipDate);

      /* Skyldes ventetiden en lukkedag, siger vi hvorfor - ellers ligner en
         uge uden afsendelse bare, at nogen har glemt at pakke. Begrundelsen
         staar i Temaindstillinger > Levering > Grund til lukkedage. */
      var udskudt = false;
      for (var d = today; ymd(d) < ymd(shipDate); d = addDays(d, 1)) {
        if (shipDays.indexOf(isoDay(d)) !== -1 && closedDates.indexOf(ymd(d)) !== -1) udskudt = true;
      }
      var grund = udskudt ? (box.dataset.closedNote || '').trim() : '';
      cutoffEl.innerHTML =
        'Næste ' + carrier + '-afsendelse <strong>' + naer + '</strong>' + (grund ? ' ' + grund : '');
    }

    /* Leveringsestimat.

       «next_day» er et konkret loefte: bestiller du inden fristen paa en
       afsendelsesdag, er den fremme dagen efter. Det konverterer bedre
       end et interval, men holder kun hvis afsendelsesdagene er sat
       rigtigt - derfor er de en indstilling og ikke haardkodet. */
    var eta;
    if ((box.dataset.promise || 'next_day') === 'next_day') {
      eta = nextDeliveryDay(addDays(shipDate, 1));
      if (ymd(eta) === ymd(addDays(today, 1))) {
        etaEl.textContent = 'Forvent levering i morgen';
      } else {
        etaEl.textContent = 'Forvent levering ' + DAGE[eta.getUTCDay()] + ' ' + formatDate(eta);
      }
    } else {
      /* Interval talt i hverdage fra afsendelsesdagen */
      function addWeekdays(from, n) {
        var d = from;
        var left = n;
        for (var i = 0; i < 60 && left > 0; i++) {
          d = addDays(d, 1);
          if (isoDay(d) <= 5) left--;
        }
        return d;
      }

      var fra = addWeekdays(shipDate, dMin);
      var til = addWeekdays(shipDate, dMax);

      if (ymd(fra) === ymd(til)) {
        etaEl.textContent = 'Hos dig ' + DAGE[fra.getUTCDay()] + ' ' + formatDate(fra);
      } else if (fra.getUTCMonth() === til.getUTCMonth()) {
        etaEl.textContent =
          'Hos dig ' + fra.getUTCDate() + '.-' + til.getUTCDate() + '. ' + MDR[til.getUTCMonth()];
      } else {
        etaEl.textContent = 'Hos dig ' + formatDate(fra).slice(3) + ' - ' + formatDate(til).slice(3);
      }
    }

    /* Varianter med "Afsendes fra"-dato: forsigtig ordlyd med korte datoer */
    if (box.dataset.afventer === 'true') {
      var kort = function (d) {
        return d.getUTCDate() + '/' + (d.getUTCMonth() + 1);
      };
      cutoffEl.textContent = 'Forventet afsendelse ' + kort(shipDate);
      if (eta) etaEl.textContent = 'Forventet levering ' + kort(eta);
    }

    box.dataset.lmmDeliveryDone = '1';
  }

  function run() {
    document.querySelectorAll('[data-lmm-delivery]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  /* Variantskift genrenderer produktinfo via Section Rendering API */
  document.addEventListener('variant:change', run);
  document.addEventListener('shopify:section:load', run);
})();
